import React, { useMemo } from 'react';
import { useFormContext } from '../Provider';
import useValidators from '../Validators/useValidator';
import CommonFieldWrapper from './CommonFieldWrapper';

const types = [
    'Other',
    'Once',
    'Weeks',
    'Months',
    'Years',
];

const Frequency = ({label, name, help, onChange, disabled, validators}) => {
    const { formData, updateField, updateValidity, isValidating, isSubmitting, formDisabled } = useFormContext();
    const value = formData[name] ?? '';
    const {isValid, error} = useValidators(value, validators, name, updateValidity);

    const [type, count] = useMemo(() => {
        return [
            value.replace(/\d/g, '').trim(),
            value.replace(/\D/g, '').trim(),
        ]
    }, [value]);

    const counts = useMemo(() => {
        const opts = (max) => Array.from({length: max}, (_, i) => i + 1);
        switch (type) {
            case 'Weeks':
                return opts(52);
            case 'Months':
                return opts(12)
            case 'Years':
                return opts(4);
            default:
                return null
        }
    }, [type]);

    const handleChange = (_type, _count) => {
        const newVal = makeString(_type, _count);
        updateField(name, newVal);
        onChange && onChange(newVal);
    }

    const makeString = (_type, _count) => {
        switch (_type) {
            case 'Weeks':
            case 'Months':
            case 'Years':
                return `${_count ? _count : 1} ${_type}`;
            default:
                return _type;
        }
    }

    const isDisabled = formDisabled || disabled || isSubmitting;

    return <CommonFieldWrapper {...{label, name, help, value, isValid, isValidating, error, validators, isDisabled}}>
        <div className="flex flex-row justify-between items-center">
            <select
                id={name+'-type'}
                name={name+'-type'}
                className="inline-block w-[45%] ml-1 p-0 border-0 border-transparent focus:border-transparent text-gray-900 sm:text-sm sm:leading-6 disabled:text-gray-400 disabled:bg-gray-100"
                defaultValue={type}
                onChange={(e) => handleChange(e.target.value, count)}
                disabled={isDisabled}
            >
                <option value="">Select</option>
                {types.map((option, index) => <option key={index} value={option}>{option}</option>)}
            </select>

            <select
                id={name+'-count'}
                name={name+'-count'}
                className="inline-block w-[45%] ml-1 p-0 border-0 border-transparent focus:border-transparent text-gray-900 sm:text-sm sm:leading-6 disabled:text-gray-400 disabled:bg-gray-100"
                defaultValue={count}
                onChange={(e) => handleChange(type, e.target.value)}
                disabled={isDisabled || !counts}
            >
                {counts && counts.map((option, index) => <option key={index} value={option}>{option}</option>)}
            </select>
        </div>

    </CommonFieldWrapper>
}

export default Frequency;